// $(window).on('scroll', function() {    
// 	var scroll = $(window).scrollTop();
// 	if (scroll >= 80) {
// 		if ($('#soccerball').length != 0) {
// 			if (!document.getElementById('soccerball').classList.contains('animate')) {
// 				document.body.style.overflow = 'hidden';
// 			}
// 			$("#soccerball").addClass("animate");
// 		} else if ($('#football').length != 0) {
// 			$("#football").addClass("animate");
// 		}
// 		$(".crack").addClass("animate");
// 	}
// 	if (scroll >= 800) {
// 		setTimeout(function () {
// 			$(".crack").addClass("hide-crack");
// 			document.body.style.overflow = 'unset';
// 		}, 500);
// 	} else {
// 		setTimeout(function () {
// 			$(".crack").addClass("hide-crack");
// 			document.body.style.overflow = 'unset';
// 		}, 2500);
// 	}
// });
window.$ = jQuery.noConflict(true);

import * as axios from 'axios';
window.axios = axios;

import Glide from '@glidejs/glide';
window.Glide = Glide;

/**
 * Vue Config
 */
import Vue from 'vue';
window.Vue = Vue;

Vue.prototype.$ = window.$ || window.jQuery;
Vue.prototype.axios = window.axios;
Vue.prototype.glide = window.Glide;

Vue.config.devtools = true;
Vue.config.productionTip = false;

Vue.filter('json', (value) => JSON.stringify(value));
Vue.prototype.toJson = function (value) {
    return JSON.stringify(value);
};
Vue.prototype.icon = function (name, classes) {
    return `<i class="icon ${classes || ''}">
        <svg viewbox="0 0 16 16" preserveAspectRatio="xMidYMid meet"><use href="#icon-${name}"></use></svg>
    </i>`;
};

Vue.component('homeshake-listings', require('./vue/homeshake-listings.vue').default);
Vue.component('neighborhoods-map', require('./vue/neighborhoods-map.vue').default);
Vue.component('search-cincinnati', require('./vue/search-cincinnati.vue').default);
Vue.component('instagram-carousel', require('./vue/instagram-carousel.vue').default);
Vue.component('cost-of-living-calculator', require('./vue/cost-of-living-calculator.vue').default);

/**
 * Let's automatically create a new vue instrance for all elements with 
 * a `data-bind="vue"` tag. Be careful not to embed instances...
 * @author LWK
 */
const VUE_ELEMENTS = document.querySelectorAll('[data-bind="vue"]');
if (VUE_ELEMENTS.length) {
	Array.from(VUE_ELEMENTS).forEach((el) => new Vue({el: el}));
}



/**
 * Animate the home hero jumbotron
 * @author HOSS
 */
if (document.getElementById('home_headline')) {
	// Animate hero scroll
	$(document).on('scroll', function() {
		$("#home_headline").css("top", Math.max(0 + 0.4*window.scrollY, 0) + "px");
	});
}

/**
 * Football Animation for FIFA 2026 promo
 * @author HOSS
 */



/**
 * Instagram Slider Module
 * @author HOSS
 */
let instaSliderElement = document.querySelector('.insta_slider-glide');
if(instaSliderElement) {
	new Glide(instaSliderElement, {
		type: 'carousel',
		perView: 4,
		peek: 100,
		gap: 30,
		autoplay: 4000,
		keyboard: true,
		hoverpause: true
	}).mount();
}


/**
 * Animate the nav on scroll
 * @author HOSS
 */
$(window).on('scroll', function() {    
	var scroll = $(window).scrollTop();
	if ($('body').hasClass('home')) {
		if (scroll >= 900) {
			$("#main-nav").addClass("scrolled");
		} else {
			$("#main-nav").removeClass("scrolled");
		}
	} else {
		if (scroll >= 120) {
			$("#main-nav").addClass("scrolled");
		} else {
			$("#main-nav").removeClass("scrolled");
		}
	}
    
});
// Add class if page is reloaded and is already scrolled
$(document).ready(function() {
	var scroll = $(window).scrollTop();
	if (scroll >= 120) {
        $("#main-nav").addClass("scrolled");
    }
});

/**
 * Animate the topics link click
 * @author HOSS
 */
/*$(document).ready(function() {
	$('.topics-anchor a').on('click', function(event) {
		event.preventDefault();
		// console.log("CLICKED!");
		var target = $(this).attr('href');
		var	buffer = parseInt($('body').css('margin-top'));
		var scrollDest = parseInt($(target).offset().top - buffer);
		$('.navbar-collapse').collapse('hide');
		$('html, body').animate({
			scrollTop: (scrollDest - 40),
		}, 1000);
	});
});*/


class App {
	constructor() {
		document.addEventListener('DOMContentLoaded', () => {
			this.collect.bind(this)();
		});
	}
	add(propertyName, object) {
		this[propertyName] = object;
		(this[propertyName].init || function(){}).bind(this[propertyName])();
	}
	call(signature, element) {
		try {
			this.envoke(((signature) => {
				signature.shift();
				return signature;
			})(signature.split('.')))(element);
		}
		catch (Exception) {
			console.warn(`Error calling ${signature} from `, element, Exception);
		}
	}
	envoke(rest, current = this) {
		return rest.length == 1 ? current[rest.shift()].bind(current) : this.envoke(rest, current[rest.shift()]);
	}
	collect() {
		for (let element of document.querySelectorAll('[app-call]')) {
			this.call(element.getAttribute('app-call'), element);
		}
	}
}
window.app = new App();